import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { of } from 'rxjs';
import { SpecificPriceWithoutDiscounts } from '../../../../../../../models/enum/shared/specific-price-without-discounts.enum';

@Injectable()
export class FireAndFlowerSaleCardStackContentViewModel extends PrintCardContentViewModel {
  // TODO BUD-10524: this theme still renders hardcoded THC and CBD instead of the default compound pools.
  //  Deliberately skipped as a deprecated theme (churned customer); this is where the pooling swap would go.
  public readonly bottomPriceSpecificPriceWithoutDiscounts$ = of([
    SpecificPriceWithoutDiscounts.LocationSpecificBasePrice,
    SpecificPriceWithoutDiscounts.CompanySpecificBasePrice,
    SpecificPriceWithoutDiscounts.BasePrice
  ]);

  public addSpaceAfterDollarSign = (price: string): string => price?.replace('$', '$ ');
}
